import React from 'react'
import NavBar from '../Component/NavBarFooter/NavBar'
import Banner from '../Component/HomePage/Banner'
import AboutSection from '../Component/HomePage/AboutSection'
import ExperienceSection from '../Component/HomePage/ExperienceSection'
import ManufacturingSection from '../Component/HomePage/ManufacturingSection'
import Textiles from '../Component/HomePage/Textiles'
import Measurements from '../Component/HomePage/Measurements'
import BlogSection from '../Component/HomePage/BlogSection'
import BrandSection from '../Component/HomePage/BrandSection'
import Footer from '../Component/NavBarFooter/Footer'

function HomePage() {
  return (
    <div>
        <NavBar/>
        <Banner/>
        <AboutSection/>
        <ExperienceSection/>
        <ManufacturingSection/>
        <Textiles/>
        <Measurements/>
        <BlogSection/>
        <BrandSection/>
        <Footer/>
    </div>
  )
}

export default HomePage